import { FC, useEffect, useState, useMemo } from "react";
import KickImage from 'Reuseables/KickImage';
import moment from "moment";

//Components
import ComponentMain from "./components/Main";
import DropoffScheduled from "./components/DropoffSchedule";

//Helpers
import { momentHandler, dateHandler } from "../../../../utils/Helpers";
import { useToast } from "../../../../helpers/dom";

//Actions
import { fetchCourierNoRedux, submitDropoff, submitDropoffConsignments } from '../../../../actions/shipperAction';

//Context

//Interfaces
import { WrapperInterface, TIMESLOT, SelectedLogistic, SelectedSchedule, DateInterface, CourierInterface } from "./definitions";

const Dropoff: FC<WrapperInterface> = ({
  onBack,
  submitSuccess,
  sale_id,
  isConsignments,
}): JSX.Element => {
  const showToast = useToast()
  const [loading, setLoading] = useState(true);
  const [photo, setPhoto] = useState(null)
  const [photoUrl, setPhotoUrl] = useState("")
  const [dropoffSchedule, setDropoffScheduled] = useState(false)
  const [selectedLogistic, setSelectedLogistic] = useState<SelectedLogistic>({ text: "", value: "" })
  const [scheduledList, setScheduledList] = useState<Array<DateInterface>>([])
  const [awbNumber, setAwbNumber] = useState("");
  const [courierList, setCourierList] = useState<Array<CourierInterface>>([])
  const [selectedDate, setSelectedDate] = useState<DateInterface | null>(null)
  const [selectedScheduled, setSelectedScheduled] = useState<SelectedSchedule>({ start_time: "", end_time: "" })

  const setPhotoHandler = (file) => {
    setPhoto(file)
    setPhotoUrl(URL.createObjectURL(file))
  }

  const deletePhoto = () => {
    setPhoto(null)
    setPhotoUrl("")
  }

  const onChangeLogistic = (e) => {
    const { value } = e.target
    setSelectedLogistic({
      text: value,
      value: value
    })
  }

  const onChangeAwbNumber = (e) => {
    setAwbNumber(e.target.value)
  }

  const resetSelectedScheduled = () => {
    setSelectedScheduled({
      start_time: "",
      end_time: ""
    })
  }

  const resetSelectedDate = () => {
    setSelectedDate(null)
  }

  const onSelectLogistic = ({ value }) => {
    setSelectedLogistic(value)

    setSelectedDate(null)
    resetSelectedScheduled()
    resetSelectedDate()
    setAwbNumber("")
  }

  const validationHandler = () => {
    if (!selectedLogistic.value) return true

    if (selectedLogistic.value === "self-drop-off" && !selectedScheduled.start_time) return true
    if (selectedLogistic.value !== "self-drop-off" && !awbNumber) return true

    return false;
  }

  const timeSlotHandler = (day: string) => {
    return TIMESLOT
  }
  const handleIsSunday = (date: string) => moment(date).format('dddd') === "Sunday";
  const momentDayHandler = (currDay: number) => {
    let _day = currDay === 0 ? moment().format() : moment().add(currDay, "day").format()

    const day = momentHandler(_day, 'ddd');
    const date = momentHandler(_day, 'Do');
    const month = momentHandler(_day, 'MMM');
    const year = momentHandler(_day, 'YYYY');
    const dateSplitted = dateHandler(date);

    return {
      fullDay: _day,
      day,
      date: dateSplitted[0],
      suffix: dateSplitted[1],
      month,
      year,
      timeslot: timeSlotHandler(_day),
      required: moment(_day).isBefore()
    }
  }

  const setDateAndTimeslot = async () => {
    try {
      const isTodayAfter6Afternoon = moment().hours() >= 18;

      let currentDate = 0;

      let dayOne = null;
      let dayTwo = null;
      let dayThree = null;

      const today = moment().format();
      const isTodaySunday = handleIsSunday(today);

      //Day 1
      if (isTodaySunday || isTodayAfter6Afternoon) {
        currentDate += 1
      }
      //@ts-ignore
      dayOne = momentDayHandler(currentDate);

      //Day 2
      const isSecondSunday = handleIsSunday(moment().add(1 + currentDate, 'day').format());

      if (isSecondSunday) {
        currentDate += 1
      }
      //@ts-ignore
      dayTwo = momentDayHandler(currentDate + 1);

      //Day 3
      const isThirdSunday = handleIsSunday(moment().add(2 + currentDate, 'day').format());
      if (isThirdSunday) {
        currentDate += 1
      }
      //@ts-ignore
      dayThree = momentDayHandler(currentDate + 2);

      //@ts-ignore
      setScheduledList([dayOne, dayTwo, dayThree])
    } catch (err) {
      console.log(err, "Err when fetching settings fn setDateAndTimeslot file Dropoff.tsx")
    }
  }

  const fetchCourierHandler = async () => {
    try {
      setLoading(true)
      await fetchCourierNoRedux()
        .then(res => res?.data)
        .then(res => {
          if (!res.data) return;
          const listOfCouriers = res.data;
          const _newList = listOfCouriers?.map(cour => ({ ...cour, value: cour?.code, text: cour?.display_name }))
          setCourierList([..._newList, { value: "self-drop-off", text: "Self Drop-off" }])
        })
        .catch(err => { throw err })
        .finally(() => {
          setLoading(false)
        })
    } catch (err) {
      setLoading(false)
      console.log(err, "Err when trying to get courier fn fetchCourierHandler file Dropoff.tsx")
    }
  }

  const parseTextHandler = (val) => {
    try {
      if (!val || typeof val != "string" || !val?.length) return "";

      const newVal = val.slice(0, 3)

      return newVal
    } catch (err) {
      console.log(err)
      return val
    }
  }

  const submitPayloadHandler = () => {
    let payload = new FormData();
    payload.append("seller_courier", selectedLogistic.value)
    payload.append("seller_awb_number", awbNumber);

    if (photo) {
      payload.append("seller_awb_image", photo);
    }

    if (selectedLogistic.value === "self-drop-off") {
      const _val = `${(selectedDate?.day)}, ${(selectedDate?.month)} ${selectedDate?.date}${selectedDate?.suffix} ${selectedScheduled.start_time} - ${selectedScheduled.end_time} (WIB)`
      payload.append("drop_off_schedule", _val);
    }

    return payload;
  }

  const submitDropoffHandler = async () => {
    try {
      setLoading(true)
      const payload = submitPayloadHandler()
      {
        isConsignments ? 
        await submitDropoffConsignments(payload, sale_id)
        .then(res => { submitSuccess() })
        .catch(err => { throw err })
        .finally(() => {
          setLoading(false)
        })
        :
        await submitDropoff(payload, sale_id)
          .then(res => { submitSuccess() })
          .catch(err => { throw err })
          .finally(() => {
            setLoading(false)
          })
      }
    } catch (err) {
      showToast(err, true)
      setLoading(false)
      console.log(err, "Err when trying to submit dropoff fn submitDropoffHandler file Dropoff.tsx")
    }
  }

  useEffect(() => {
    const setting = new Promise((resolve) => {
      setDateAndTimeslot()
      setTimeout(() => {
        resolve('foo');
      }, 1000);
    })

    setting.then(() => fetchCourierHandler())
  }, [])

  if (dropoffSchedule) return (
    <DropoffScheduled
      loading={loading}
      selectedScheduled={selectedScheduled}
      scheduledList={scheduledList}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      setDropoffScheduled={setDropoffScheduled}
      setSelectedScheduled={setSelectedScheduled}
    />
  )

  return (
    <ComponentMain
      loading={loading}
      photo={photo}
      photoUrl={photoUrl}
      selectedLogistic={selectedLogistic}
      awbNumber={awbNumber}
      selectedScheduled={selectedScheduled}
      selectedDate={selectedDate}
      courierList={courierList}
      parseTextHandler={parseTextHandler}
      setDropoffScheduled={setDropoffScheduled}
      onChangeAwbNumber={onChangeAwbNumber}
      onChangeLogistic={onChangeLogistic}
      setPhotoHandler={setPhotoHandler}
      deletePhoto={deletePhoto}
      onBack={onBack}
      onSelectLogistic={onSelectLogistic}
      isValid={validationHandler()}
      submitDropoffHandler={submitDropoffHandler}
    />
  )
}
Dropoff.defaultProps = {
  onBack: () => { }
}

export default Dropoff;